import React from "react";
import { Routes, Route, BrowserRouter, Navigate } from "react-router-dom";

import { AuthProvider } from "./contexts/AuthContext";

import ProtectedRoute from "./components/ProtectedRoute";
import AccountLayout from "./components/layout/AccountLayout";
import Login from "./pages/admin/Login";
import Dashboard from "./pages/admin/Dashboard";
import Gallery from "./pages/admin/Gallery";
import ViewProject from "./pages/ViewProject";
const Analytics = React.lazy(() => import("./pages/admin/Analytics"));
const ThemeFiles = React.lazy(() => import("./pages/admin/ThemeFiles"));
const ConsultationRequests = React.lazy(() => import("./pages/admin/ConsultationRequests"));

function App() {
  return (
    <AuthProvider>
      <div
        id="kt_docs_toast_stack_container"
        className="toast-container position-fixed bottom-0 end-0 p-3 z-index-9999"
      ></div>
      <BrowserRouter basename={"/"}>
        <Routes>
          <Route path="/view-project/:token" element={<ViewProject />} />
          <Route path="/account/login" element={<Login />} />
          <Route
            path="/account"
            element={
              <ProtectedRoute>
                <AccountLayout />
              </ProtectedRoute>
            }
          >
            <Route index element={<Navigate to="dashboard" replace />} />
            <Route path="dashboard" element={<Dashboard />} />
            <Route path="gallery" element={<Gallery />} />
            <Route path="consultation-requests" element={<React.Suspense fallback={<div className="section-card">Loading requests…</div>}><ConsultationRequests /></React.Suspense>} />
            <Route
              path="analytics"
              element={
                <React.Suspense fallback={<div className="section-card">Loading analytics…</div>}>
                  <Analytics />
                </React.Suspense>
              }
            />
            <Route
              path="theme-files"
              element={
                <React.Suspense fallback={<div className="section-card">Loading site editor…</div>}>
                  <ThemeFiles />
                </React.Suspense>
              }
            />
          </Route>
          <Route
            path="*"
            element={<Navigate to="/account/dashboard" replace />}
          />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
